import { Link, useNavigate } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { useAuth } from "../../js/hooks/useAuth";
import { productLabel } from "../../js/auth/packageAccess";
import { isProfessionalRole, resolvePostAuthPath } from "../../js/auth/onboardingState";
import { payUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";
import DeskPlatformBadge from "../../components/desk/DeskPlatformBadge";
import { isLocalSandbox, runSandboxCheckout } from "../../js/billing/billingDesk";
import { useStore } from "../../js/state/store";

export default function SubscribeActivate() {
  const navigate = useNavigate();
  const { session } = useAuth();
  const { dispatch } = useStore();
  const sandbox = isLocalSandbox();

  if (!session || !isProfessionalRole(session.role)) {
    return (
      <AppLayout>
        <article className="card auth-card">
          <h1>Activate your subscription</h1>
          <p className="page-lead">Professional subscriptions apply to agents and brokers.</p>
        </article>
      </AppLayout>
    );
  }

  return (
    <AppLayout variant={session.role === "broker" || session.role === "corporate" ? "broker" : "agent"}>
      <article className="card auth-card onboarding-card">
        <DeskPlatformBadge />
        <h1>Activate {productLabel(session)}</h1>
        <p className="page-lead">
          Agent Standard and Broker Office desks require an active subscription. Checkout lives on
          DreamHome Journey — you return here automatically after payment.
        </p>
        <div className="onboarding-actions">
          <a className="primary-btn" href={payUrl(session)} {...JOURNEY_LINK_PROPS}>
            Continue to secure checkout
          </a>
          {sandbox ? (
            <button
              type="button"
              className="ghost-btn"
              onClick={() => {
                const { session: nextSession } = runSandboxCheckout(session);
                if (nextSession) {
                  dispatch({ type: "SET_SESSION", payload: nextSession });
                  navigate(resolvePostAuthPath(nextSession), { replace: true });
                }
              }}
            >
              Simulate sandbox payment
            </button>
          ) : null}
          <Link className="ghost-btn" to="/account?tab=billing">
            Billing & sandbox tools
          </Link>
        </div>
        <p className="muted">
          Beta and comped accounts skip this step. If you already paid, refresh after returning from
          checkout.
        </p>
      </article>
    </AppLayout>
  );
}
